import { AfterViewInit, Component, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-geometric-animation',
    standalone: true,
    imports: [],
    templateUrl: './geometric-animation.html',
    styleUrl: './geometric-animation.scss'
})
export class GeometricAnimation implements AfterViewInit, OnDestroy {
    private canvas!: HTMLCanvasElement;
    private ctx!: CanvasRenderingContext2D;
    private animationId!: number;
    private formas: any[] = [];
    private quantidadeFormas = 60;
    private cores = ['#38bdf8', '#818cf8', '#c084fc', '#e879f9', '#2dd4bf'];

    ngAfterViewInit() {
        this.canvas = document.getElementById('canvas-fundo-geometric') as HTMLCanvasElement;
        if (!this.canvas) return;
        this.ctx = this.canvas.getContext('2d')!;
        this.iniciar();
        window.addEventListener('resize', this.redimensionarCanvas.bind(this));
    }

    ngOnDestroy() {
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }
        window.removeEventListener('resize', this.redimensionarCanvas.bind(this));
    }

    private redimensionarCanvas() {
        if (this.canvas) {
            this.canvas.width = window.innerWidth;
            this.canvas.height = window.innerHeight;
        }
    }

    private iniciar() {
        this.redimensionarCanvas();
        for (let i = 0; i < this.quantidadeFormas; i++) {
            this.formas.push(this.criarForma());
        }
        this.animar();
    }

    private criarForma() {
        return {
            x: Math.random() * this.canvas.width,
            y: Math.random() * this.canvas.height,
            tamanho: Math.random() * 40 + 10,
            dx: (Math.random() - 0.5) * 0.8,
            dy: (Math.random() - 0.5) * 0.8,
            angulo: Math.random() * Math.PI * 2,
            velocidadeRotacao: (Math.random() - 0.5) * 0.008,
            cor: this.cores[Math.floor(Math.random() * this.cores.length)],
            tipo: Math.floor(Math.random() * 3),
            opacidade: Math.random() * 0.06 + 0.02,
            atualizar: function (canvasWidth: number, canvasHeight: number) {
                this.x += this.dx;
                this.y += this.dy;
                this.angulo += this.velocidadeRotacao;

                if (this.x - this.tamanho > canvasWidth) this.x = -this.tamanho;
                else if (this.x + this.tamanho < 0) this.x = canvasWidth + this.tamanho;

                if (this.y - this.tamanho > canvasHeight) this.y = -this.tamanho;
                else if (this.y + this.tamanho < 0) this.y = canvasHeight + this.tamanho;
            },
            desenhar(ctx: CanvasRenderingContext2D) {
                ctx.save();
                ctx.globalAlpha = this.opacidade;
                ctx.fillStyle = this.cor;
                ctx.translate(this.x, this.y);
                ctx.rotate(this.angulo);
                ctx.beginPath();
                if (this.tipo === 0) ctx.arc(0, 0, this.tamanho, 0, Math.PI * 2);
                else if (this.tipo === 1) ctx.rect(-this.tamanho / 2, -this.tamanho / 2, this.tamanho, this.tamanho);
                else {
                    ctx.moveTo(0, -this.tamanho);
                    ctx.lineTo(this.tamanho, this.tamanho);
                    ctx.lineTo(-this.tamanho, this.tamanho);
                }
                ctx.fill();
                ctx.restore();
            }
        };
    }

    private animar() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.formas.forEach((forma) => {
            forma.atualizar(this.canvas.width, this.canvas.height);
            forma.desenhar(this.ctx);
        });
        this.animationId = requestAnimationFrame(this.animar.bind(this));
    }
}
